import {AppLayoutProps} from "../interface/AppLayout";

export default function AppLayout({children}: AppLayoutProps): JSX.Element {
    return <div className={'flex bg-[#F5F5F5]'}>
        {children}
    </div>
}
